import { render, staticRenderFns } from "./RootRouterView.vue?vue&type=template&id=0f771dd7&scoped=true&"
import script from "./RootRouterView.vue?vue&type=script&lang=js&"
export * from "./RootRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f771dd7",
  null
  
)

export default component.exports